import React from 'react';
import { ContentCourseSpeechRateListService } from '../../services/ContentListService';
import ContentCourseSpeechRateSummary from './ContentCourseSpeechRateSummary';
import { observer } from 'mobx-react';

const ContentCourseSpeechRateSummaryContainer = () => {
  const summary = ContentCourseSpeechRateListService.getChart();
  return (
    <ContentCourseSpeechRateSummary
      isLoading={
        ContentCourseSpeechRateListService.fetchCurrent.fetching ||
        ContentCourseSpeechRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentCourseSpeechRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentCourseSpeechRateSummaryContainer);
